module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_vm._v("跑后分享文案")]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper run-share-copy"
  }, [_c('div', {
    staticClass: "left-panel"
  }, [_c('div', {
    staticClass: "row title"
  }, [_vm._v("跑后分享按钮文案")]), _vm._v(" "), _c('div', {
    staticClass: "row tip"
  }, [_vm._v("自定义文案在生效期内，APP优先展示自定义文案")]), _vm._v(" "), _c('div', {
    staticClass: "row info-row"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("系统默认文案")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.defaultCopy))])]), _vm._v(" "), _c('div', {
    staticClass: "row info-row"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("自定义文案")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [(_vm.customCopy.content) ? [_c('div', [_vm._v(_vm._s(_vm.customCopy.content))]), _vm._v(" "), _c('div', {
    staticClass: "effect-time"
  }, [_vm._v("\n              生效时间：" + _vm._s(_vm.customCopy.startTime) + "至" + _vm._s(_vm.customCopy.endTime) + "\n            ")])] : _c('span', [_vm._v("未设置内容")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row action-row"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickEdit
    }
  }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.clickDelete
    }
  }, [_vm._v("删除")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "right-panel"
  }, [_c('div', {
    staticClass: "preview-placeholder"
  }, [_vm._v("示意图")]), _vm._v(" "), (_vm.previewImage) ? _c('img', {
    staticClass: "preview-img",
    attrs: {
      "src": require("../../../../assets/images/copywriting-1.png")
    }
  }) : _vm._e()])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "自定义文案",
      "visible": _vm.editDialog.visible,
      "modal-append-to-body": false,
      "width": "520px"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.editDialog, "visible", $event)
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "80px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "文案",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "最多12个字",
      "maxlength": 12
    },
    model: {
      value: (_vm.editForm.content),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "content", $$v)
      },
      expression: "editForm.content"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "生效时间",
      "required": ""
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetimerange",
      "placeholder": "选择生效时间",
      "format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: (_vm.editForm.timeRange),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "timeRange", $$v)
      },
      expression: "editForm.timeRange"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "dialog-footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickSave
    }
  }, [_vm._v("确定")])], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "是否删除自定义文案?",
      "visible": _vm.deleteDialog.visible,
      "modal-append-to-body": false,
      "width": "420px"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.deleteDialog, "visible", $event)
      }
    }
  }, [_c('div', {
    staticClass: "delete-tip"
  }, [_vm._v("删除后，APP将展示系统默认文案")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "dialog-footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.deleteDialog.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirmDelete
    }
  }, [_vm._v("确定")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a28da6cc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/Copywriting/RunShareCopy/RunShareCopy.vue
// module id = 1111
// module chunks = 0